export const REQUEST_LAWYER_REJECTED_CLAIMS: string =
  'REQUEST_LAWYER_REJECTED_CLAIMS';
export const SET_LAWYER_REJECTED_CLAIMS: string = 'SET_LAWYER_REJECTED_CLAIMS';
export const REQUEST_SEARCH_REJECTED_CLAIMS: string =
  'REQUEST_SEARCH_REJECTED_CLAIMS';
export const SET_SEARCH_REJECTED_CLAIMS: string = 'SET_SEARCH_REJECTED_CLAIMS';
